import React from 'react';
import { Menu } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { menuConfig } from '../../config/menuConfig';
import './SidebarMenu.css';

const SidebarMenu = ({ 
  collapsed, 
  selectedKeys, 
  openKeys, 
  onSelect, 
  onOpenChange 
}) => {
  const navigate = useNavigate();
  const { roles = [], permissions = [] } = useSelector(state => state.auth);

  const hasRole = (roleCode) => {
    // 兼容 roles 为字符串数组或对象数组两种形态（历史数据结构差异）
    return roles.some(r => r === roleCode || r.code === roleCode || r.roleCode === roleCode);
  };

  const hasPermission = (permissionCode) => {
    // 兼容 permissions 为字符串数组或对象数组两种形态
    return permissions.some(p => p === permissionCode || p.code === permissionCode);
  };

  const canAccess = (item) => {
    // 菜单可见性控制：任一/全部角色与权限要求 + 排除角色
    const requiredRoles = item?.requiredRoles || [];
    const requiredAllRoles = item?.requiredAllRoles || [];
    const requiredPermissions = item?.requiredPermissions || [];
    const requiredAllPermissions = item?.requiredAllPermissions || [];
    const excludeRoles = item?.excludeRoles || [];

    const anyRoleOk = requiredRoles.length === 0 || requiredRoles.some(hasRole);
    const allRoleOk = requiredAllRoles.length === 0 || requiredAllRoles.every(hasRole);
    const anyPermOk = requiredPermissions.length === 0 || requiredPermissions.some(hasPermission);
    const allPermOk = requiredAllPermissions.length === 0 || requiredAllPermissions.every(hasPermission);
    const excluded = excludeRoles.length > 0 && excludeRoles.some(hasRole);
    return anyRoleOk && allRoleOk && anyPermOk && allPermOk && !excluded;
  };

  const filterMenuItemsByAccess = (items) => {
    if (!Array.isArray(items)) return [];
    // 递归过滤：子菜单全部被过滤后且父节点无 path，则隐藏该父节点
    return items
      .filter(canAccess)
      .map(i => {
        if (!i.children || i.children.length === 0) return i;
        return { ...i, children: filterMenuItemsByAccess(i.children) };
      })
      .filter(i => !(i.children && i.children.length === 0 && !i.path));
  };

  // 生成菜单项
  const generateMenuItems = (items) => {
    return items.map(item => {
      const IconComponent = item.icon;
      
      if (item.children && item.children.length > 0) {
        return {
          key: item.key,
          icon: IconComponent ? <IconComponent /> : null,
          label: item.title,
          children: generateMenuItems(item.children)
        };
      }

      return {
        key: item.key,
        icon: IconComponent ? <IconComponent /> : null,
        label: item.title,
        onClick: () => {
          if (item.path) {
            navigate(item.path);
          }
        }
      };
    });
  };

  const visibleMenuConfig = filterMenuItemsByAccess(menuConfig);
  const menuItems = generateMenuItems(visibleMenuConfig);

  const handleMenuSelect = ({ selectedKeys }) => {
    onSelect(selectedKeys);
  };

  const handleSubMenuOpen = (openKeys) => {
    onOpenChange(openKeys);
  };

  return (
    <div className={`sidebar-menu ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-logo">
        <img
          className="sidebar-logo-image"
          src="/images/LOGO-04.png"
          alt="小金蝉"
        />
        {!collapsed && <span className="logo-text">小金蝉</span>}
      </div>
      
      <Menu
        mode="inline"
        theme="light"
        inlineCollapsed={collapsed}
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        items={menuItems}
        onSelect={handleMenuSelect}
        onOpenChange={handleSubMenuOpen}
        className="sidebar-menu-content"
      />
    </div>
  );
};

export default SidebarMenu;
